<template lang="html">

    <article class="programa-activo">

        <div class="contenedor-foto" v-if="!!data.urlImagen" :style="`background:url(${data.urlImagen}) center/cover no-repeat`">
        </div>

        <div class="contenedor-texto">
            <h2 class="titulo">{{data.titulo}}</h2>
            <h3 class="fecha">{{(!!!data.fechaFin) ? 'a partir del' : 'del'}} {{data.fechaInicio}} {{(!!data.fechaFin) ? 'al' : ''}} {{data.fechaFin}}</h3>
            <a href="" class="link">Ver detalle</a>
        </div>

        <router-link class="enlace-cover" :to="$t('enlaces.programas')+'/'+data.urlAcceso"></router-link>

    </article>

</template>

<script lang="js">
    export default {
        name: 'programa-activo',
        props : ['data']
    }
</script>


// WEBPACK FOOTER //
// src/components/parts/programa-activo.vue